import axios from 'axios'

const BASE_URL = import.meta.env.VITE_API_BASE_URL

export const getCancelAccountCode = async (code) => {
  return await axios
    .get(`${BASE_URL}cancel-accounts-code/${code}`)
    .then((response) => {
      return {
        data: response.data,
        responseStatus: response.status,
      }
    })
    .catch(function (error) {
      if (error.response.status === 401) {
        window.localStorage.clear()
        window.location.reload()
      }
      console.log('error getCancelAccountCode', error.response.data)
      return error
    })
}

export const postCancelAccount = async (body) => {
  const STORAGE_TOKEN = JSON.parse(window.localStorage.getItem('token'))

  let config = {
    headers: {
      Authorization: 'Bearer ' + STORAGE_TOKEN,
    },
    withCredentials: true,
  }
  return await axios
    .post(`${BASE_URL}cancel-accounts`, body, config)
    .then((response) => {
      return {
        data: response.data,
        responseStatus: response.status,
      }
    })
    .catch(function (error) {
      if (error.response.status === 401) {
        window.localStorage.clear()
        window.location.reload()
      }
      console.log('error postCancelAccount', error.response.data)
      return error
    })
}

export const confirmCancelPlan = async (code) => {
  return await axios
    .post(`${BASE_URL}cancel-plan/confirm`, { code })
    .then((response) => {
      return {
        data: response.data,
        responseStatus: response.status,
      }
    })
    .catch(function (error) {
      console.log('error confirmCancelPlan', error.response?.data)
      return error
    })
}

export const putCancelAccount = async (id, body) => {
  return await axios
    .put(`${BASE_URL}cancel-accounts/${id}`, body)
    .then((response) => {
      return {
        data: response.data,
        responseStatus: response.status,
      }
    })
    .catch(function (error) {
      if (error.response.status === 401) {
        window.localStorage.clear()
        window.location.reload()
      }
      console.log('error putCancelAccount', error.response.data)
      return error
    })
}
